import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Releases from './components/pages/Releases';
import Contact from './components/pages/Contact';
import SignUp from './components/pages/SignUp';
import NotFound from './components/pages/NotFound';

function App() {
  return (
    <Router>
      <div className='site-wrap'>
        <Navbar />
        <main className='site-main'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/releases' element={<Releases />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/sign-up' element={<SignUp />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
